var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSpirit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE477"
    },
    d: "M329.657,182.323l52.673,57.136c3.208,0.258,6.452,0.389,9.726,0.389 c33.116,0,63.097-13.423,84.799-35.125L445.687,141l-53.631-21.076l-45.703,15.959L329.657,182.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9F22"
    },
    d: "M476.855,204.723c21.702-21.702,35.125-51.683,35.125-84.799l-53.627-24.257l-66.297,24.257 L476.855,204.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD00"
    },
    d: "M392.056,119.924H511.98c0-33.116-13.423-63.097-35.125-84.799l-60.502,18.542L392.056,119.924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE477"
    },
    d: "M392.056,0l-23.703,47.667l23.703,72.257l0,0l84.799-84.799C455.153,13.423,425.172,0,392.056,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9F22"
    },
    d: "M307.257,35.125l17.763,60.542l67.036,24.257V0C358.94,0,328.959,13.423,307.257,35.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD00"
    },
    d: "M307.257,35.125c-21.702,21.702-35.125,51.683-35.125,84.799l57.525,62.399l62.399-62.399 L307.257,35.125z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BEEBFA"
    },
    points: "360.055,512 365.261,448.215 175.81,428.199 195.826,512 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E1F4FA"
    },
    points: "32.021,512 195.826,512 195.826,428.199 26.815,448.215 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27726"
    },
    d: "M379.33,275.845c0,0-80.012-62.842-203.52-62.842l20.016,235.212h169.435L379.33,275.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9F22"
    },
    d: "M12.323,270.661l14.492,177.553h169.012V213.003C88.595,213.118,26.764,229.809,12.323,270.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEEBFA"
    },
    d: "M379.33,275.845l12.726-155.921h-196.23L175.81,189.5l20.016,84.143 c21.488-3.942,42.591-7.954,85.554-7.954C332.473,265.689,352.655,271.363,379.33,275.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1F4FA"
    },
    d: "M0.02,119.924l12.303,150.737c27.814,4.533,47.67,10.527,100.178,10.527 c41.477,0,62.58-3.74,83.325-7.545V119.924H0.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9E5015"
    },
    d: "M266.138,265.872c0-17.474-71.167-25.637-90.116-22.289l20.016,99.955h70.1V265.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27726"
    },
    d: "M195.826,243.619c-18.375,3.371-69.888-0.309-69.888,37.426v62.493h70.1v-99.955 C195.968,243.595,195.895,243.606,195.826,243.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ECEF4"
    },
    d: "M266.138,203.339h-70.1L176.022,235l20.016,38.604c18.708-3.433,37.181-6.908,70.1-7.732V203.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EE2F8"
    },
    d: "M125.938,203.339v77.706c32.846-0.714,51.513-4.031,69.888-7.402 c0.071-0.013,0.141-0.026,0.212-0.039v-70.265H125.938z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpirit);
export default __webpack_public_path__ + "static/media/icon-spirit.a08bb5c6bd1108e51f6a7759af0d374e.svg";
export { ForwardRef as ReactComponent };